import { storage } from 'utils/localStorage'
import { create } from 'zustand'

interface Store {
  token: string
  setToken: (token: string) => void
}

export const useUserStore = create<Store>((set) => ({
  token: (() => {
    return storage.getValue('token') ?? ''
  })(),
  setToken: (token) => {
    set(() => ({ token }))

    storage.setValue('token', token)
  },
}))
